import { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { protectedRoutes } from '../config/routes';


const LoadingFallback = () => (
  <div className="flex items-center justify-center w-full h-full min-h-[200px]">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
  </div>
);

const Main = ({ children }) => {
  return (
    <div className=" w-full h-full flex flex-col border-l p-4 sm:p-6 space-y-4 border-gray-300 dark:border-gray-700 border-opacity-50 bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 overflow-hidden">
      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        {children || (
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              {protectedRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={route.element}
                />
              ))}
            </Routes>
          </Suspense>
        )}
      </div>
    </div>
  );
};

export default Main;